import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
let global_db = null;


export const initializeFSTORE = () =>{
    const app = initializeApp({
        apiKey: 'AIzaSyCq_nPOI4NBgx-05T4PmYzas3_uhEPE-Kc',
        authDomain: 'demoda-inside.firebaseapp.com',
        databaseURL: 'https://demoda-inside.firebaseio.com',
        projectId: 'demoda-inside',
        storageBucket: 'demoda-inside.appspot.com',
        messagingSenderId: '396447840313',
        appId: '1:396447840313:web:1c9285028131e4f7a1b5e8',
    },"app");
    const db = getFirestore(app)
    global_db = db
    return global_db
}

export const get_global_db = () => {
    return global_db
}